module.exports = __webpack_public_path__ + "static/media/HR-Reports-meter.b342b2b0.gif";